export class TokenMalformedException extends Error {
  constructor(message) {
    super(message);
  }
}